module.exports = __webpack_public_path__ + "static/media/ORGDASH-Analytics.6a8cf0e0.png";